import styled from 'styled-components';
import palette from '../../theme/palette';

const Divider = styled.div`
  border: 1px solid ${palette.greyBorder};
  margin-bottom: 35px;
  margin-top: 35px;
`;

export default Divider;
